import React from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Envoy Icon component using the Envoy logo SVG path.
 */
export default function EnvoyIcon({color, ...props}: {
    color?: string;
} & Omit<SvgIconProps, 'color'>) {
    const fill = color || '#FA4338';
    return (
        <SvgIcon {...props} viewBox="0 0 27 32">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M9.74981 9.3108H16.998C17.6215 9.3108 18.1278 8.80498 18.1278 8.18097C18.1278 7.55747 17.6215 7.05115 16.998 7.05115H9.74981C9.1263 7.05115 8.62048 7.55747 8.62048 8.18097C8.62048 8.80498 9.1263 9.3108 9.74981 9.3108Z"
                fill={fill}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M24.7343 28.4733C24.7343 29.1729 24.1669 29.7408 23.4667 29.7408H3.52728C2.8271 29.7408 2.25965 29.1729 2.25965 28.4733V3.52645C2.25965 2.82682 2.8271 2.2589 3.52728 2.2589H23.4667C24.1669 2.2589 24.7343 2.82682 24.7343 3.52645V28.4733ZM24.1274 -0.000244141H2.86681C1.28365 -0.000244141 0 1.28333 0 2.86639V29.1333C0 30.7164 1.28365 32 2.86681 32H24.1274C25.7106 32 26.9943 30.7164 26.9943 29.1333V2.86639C26.9943 1.28333 25.7106 -0.000244141 24.1274 -0.000244141Z"
                fill={fill}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M17.213 22.6893H10.8798V19.7821H14.4741C15.0976 19.7821 15.6034 19.2768 15.6034 18.6527C15.6034 18.0287 15.0976 17.5229 14.4741 17.5229H10.8798V14.8155H16.939C17.5631 14.8155 18.0689 14.3097 18.0689 13.6857C18.0689 13.0617 17.5631 12.5564 16.939 12.5564H9.74993C9.12642 12.5564 8.62061 13.0617 8.62061 13.6857V23.8191C8.62061 24.4426 9.12642 24.9489 9.74993 24.9489H17.213C17.837 24.9489 18.3428 24.4426 18.3428 23.8191C18.3428 23.1951 17.837 22.6893 17.213 22.6893Z"
                fill={fill}
            />
        </SvgIcon>
    );
}
